import { Component, Input, OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { AreaService } from 'src/app/arealist.service';
import { CommonService } from 'src/app/Shared/Common/common.service';
import { SharedService } from 'src/app/Shared/Common/shared.service';
import { PropertyPostsService } from 'src/app/Shared/PostRequests/property-posts.service';

@Component({
  selector: 'app-builder-network-profile-list',
  templateUrl: './builder-network-profile-list.component.html',
  styleUrls: ['./builder-network-profile-list.component.css']
})
export class BuilderNetworkProfileListComponent implements OnInit {

  @Input() PortalType: string = 'Mobile';
  isLoader: boolean = false;
  selectedAreasID: any[] = [];
  areasList: any[] = [];
  arrList: any[] = [];
  authData: any;
  userProfileInfo: any;
  buildersList: any[] = [];

  constructor(private builderPostCommonService: CommonService, private builderPostPropertyPostsService: PropertyPostsService
    , private sharedService: SharedService, private builderPostRouter: Router, private areaService: AreaService) {
    this.areasList = this.areaService.getAreas();
  }

  ngOnInit() {
    this.authData = localStorage.getItem('authData') == undefined ? '' : JSON.parse(localStorage.getItem('authData'));
    this.userProfileInfo = localStorage.getItem('authProfileData') == undefined ? '' : JSON.parse(localStorage.getItem('authProfileData'));

    if (this.authData == '') {
      this.builderPostCommonService.CallToster('E', 'Invalid user authencation, Please re-login...!');
      setTimeout(() => {
        if (this.PortalType == 'Mobile')
          this.builderPostRouter.navigateByUrl('/m/');
        else
          this.builderPostRouter.navigateByUrl('/');
      }, 1000);
    }
  }

  LoadAgentsByAreas() {
    try {
      document.getElementById('txt-search').innerText = '';
      this.arrList = [];
      let strArs = '';
      this.selectedAreasID.forEach((ars) => {
        strArs = ars.AreaID + ',';
      });
      this.isLoader = true;
      this.builderPostPropertyPostsService.GetBuilderListUserAreas(this.authData.UserID, strArs).subscribe(res => {
        this.isLoader = false;
        if (res.status == 1) {
          this.buildersList = res.body;
        }

      }, err => {
        this.isLoader = false;
      });

    } catch (error) {
      this.isLoader = false;
    }
  }

  doSearch(eve: any): void {
    if (eve.target.value.length > 2) {
      this.arrList = this.areasList.filter(function (x) {
        return x.AreaName.toLowerCase().indexOf(eve.target.value.toLowerCase()) > -1;
      });
    }
    else {
      this.arrList = [];
    }
  }

  addPreferredAreas(event: any, arr: any) {
    if (event.target.checked) {
      //console.log('Checked');
      this.selectedAreasID.push(arr);
    }
    else {
      //console.log('UnChecked');
      this.selectedAreasID = this.selectedAreasID.filter((item) => {
        if (item.AreaID != arr.AreaID)
          return item;
      });
    }
  }

  removePreferredAreas(arr: any) {
    this.selectedAreasID = this.selectedAreasID.filter((item) => {
      if (item.AreaID != arr.AreaID)
        return item;
    });
  }

  doSearchAgents(): void {
    try {

    } catch (error) {

    }
  }

  ReturnPreferredAreasNames(strars: string): string {
    //console.log(JSON.parse(strars));
    let arsList = [] = JSON.parse(strars);
    let strNames = '';
    arsList.forEach(element => {
      strNames += element.AreaName + ', '
    });
    return (strNames.substring(0, strNames.length - 2)).toUpperCase();
  }

  gotoAgentPostViews(aid: any) {
    if (this.PortalType == 'Mobile')
      this.builderPostRouter.navigate(['/m/viewbuildersposts'], { queryParams: { page: this.builderPostCommonService.encryptData(JSON.stringify(aid)) } });
    else
    this.builderPostRouter.navigate(['/viewbuildersposts'], { queryParams: { page: this.builderPostCommonService.encryptData(JSON.stringify(aid)) } });
  }

  gotoProfilePage() {
    if (this.PortalType == 'Mobile')
      this.builderPostRouter.navigateByUrl('/m/myprofile');
    else
      this.builderPostRouter.navigateByUrl('/myprofile');
  }

}